export function calculateObjectivesTotal(objectives) {
  return (objectives || []).reduce((sum, obj) => sum + (parseFloat(obj.percentage) || 0), 0);
}